import React from "react";
import SimpleSectionHeader from "./SimpleSectionHeader";

const ShippingPolicy = () => {
  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Full-width Section Header */}
      <div className="w-full bg-white">
        <SimpleSectionHeader title="Shipping Policy" />
        <div className="flex justify-center mt-2"></div>
      </div>

      {/* Main Content Container */}
      <div className="py-10 px-4 sm:px-10">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 sm:p-12">
          <p className="text-gray-700 mb-6 text-center">
            Shipping & Delivery Policy
          </p>

          <p className="text-gray-700 mb-4">
            We don’t provide Shipping and delivery service for International
            buyers, subscribers and members, in some cases orders are shipped
            and delivered through registered international courier companies
            and/or International speed post only the charges payable by the
            subscriber or buyer. For domestic buyers and subscribers, orders are
            shipped through registered domestic courier companies and /or speed
            post only. Orders are shipped within 0-2 days or as per the delivery
            date agreed at the time of order confirmation and delivering of the
            shipment subject to Courier Company / post office norms. Books At
            Doorsteps is not liable for any delay in delivery by the courier
            company / postal authorities and only guarantees to hand over the
            consignment to the courier company or postal authorities within 0-2
            days from the date of the order and payment or as per the delivery
            date agreed at the time of order confirmation. Delivery of all
            orders will be to the address provided by the buyer. Delivery of our
            services will be confirmed on your mail ID as specified during
            registration. For any issues in utilizing our services you may
            contact our helpdesk on 8600040039 or support@booksatdoorsteps.com
          </p>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;
